import alt from 'components/Dispatcher';

class SearchFieldsActions {
  constructor() {
    this.generateActions(
      'clearAllSearchFieldStates',
      'clearMyOrLibraryTagSearchFieldStates',
      'clearMenuItemStatus',
      'clearShouldClearSearchTerm',
      'removeSearchField',
      'removeSearchType',
      'removeStringSearchFieldSelectedValue',
      'updateSearchWidgetToggleState',
      'updateBooleanSearchField',
      'updateBooleanSearchExpression',
      'updateDatetimeSearchExpression',
      'updateDatetimeSearchField',
      'updateEnumSearchExpression',
      'updateEnumSearchField',
      'updateNumericSearchExpression',
      'updateNumericSearchField',
      'updatePhoneSearchField',
      'updateSearchExpression',
      'updateSearchFieldsState',
      'updateSearchFieldsStateInWhole',
      'updateStringSearchField',
      'updateStringSearchFieldSelectedOptionKey',
      'updateStringSearchExpression',
      'updateComboboxSearchFieldSelectedOptionKey',
      'updateRadioButtonsSelectedKey',
      'updateKeywordTopic',
      'clearKeywordTopic'
    );
  }
}

export default alt.createActions(SearchFieldsActions);
